import React from "react";
import SectionHeading from "../Common/SectionHeading";

const PrivacyPolicyArea = () => {
  return (
    <>
     <style>
        {`
          ul li {
            color: grey;
            list-style: none;
            padding: 0;
          }
        `}
      </style>
      <section id="tour_details_main" className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
            <div className="terms_service_content">
      <SectionHeading heading="Privacy Policy" />
     
      <div className="terms_item">
        <h4>1. Information We Collect</h4>
        <ul>
          <li>
            <strong>Personal Information:</strong> Includes name, email
            address, phone number, and other identifying details.
          </li>
          <li>
            <strong>Non-Personal Information:</strong> Browser type, IP address,
            and browsing behavior on our website.
          </li>
          <li>
            <strong>Cookies:</strong> Small data files to enhance your browsing
            experience.
          </li>
        </ul>
      </div>
      <div className="terms_item">
        <h4>2. How We Use Your Information</h4>
        <ul>
          <li>To provide and improve our services.</li>
          <li>To personalize your experience on our website.</li>
          <li>To send promotional emails or updates (with your consent).</li>
          <li>To respond to customer inquiries and support requests.</li>
        </ul>
      </div>
      <div className="terms_item">
        <h4>3. Sharing Your Information</h4>
        <ul>
          <li>
            We do not sell or rent your personal information to third parties.
          </li>
          <li>
            Information may be shared with trusted partners to provide services
            on our behalf.
          </li>
          <li>
            We may disclose information if required by law or to protect our
            legal rights.
          </li>
        </ul>
      </div>
      <div className="terms_item">
        <h4>4. Your Choices</h4>
        <ul>
          <li>Opt-out of marketing communications.</li>
          <li>Access, update, or delete your personal information.</li>
          <li>Disable cookies in your browser settings.</li>
        </ul>
      </div>
      <div className="terms_item">
        <h4>5. Data Security</h4>
        <p>
          We use industry-standard measures to protect your data from
          unauthorized access, loss, or misuse. However, no method of
          transmission over the internet is 100% secure.
        </p>
      </div>
      <div className="terms_item">
        <h4>6. Third-Party Links</h4>
        <p>
          Our website may contain links to third-party websites. We are not
          responsible for their privacy practices. Please review their policies
          separately.
        </p>
      </div>
      <div className="terms_item">
        <h4>7. Changes to This Policy</h4>
        <p>
          We may update this Privacy Policy from time to time. Changes will be
          posted on this page with the updated effective date.
        </p>
      </div>
      <div className="terms_item">
        <h4>8. Contact Us</h4>
        <p>
          If you have any questions about this Privacy Policy or how your data
          is handled, please contact us:
        </p>
        <ul>
          <li>
            <strong>Email:</strong>{" "}
            <a href="mailto:Info@houseofpolani.pk">Info@houseofpolani.pk</a>
          </li>
          <li>
            <strong>Phone:</strong>{" "}
            <a href="tel:+922132410444">(021) 32410444</a>
          </li>
        </ul>
      </div>
    </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicyArea;
